/* =========================================
   Hero Section - Video Modal
========================================= */

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("video-modal");
  const openBtn = document.getElementById("watch-demo-btn");
  const closeBtn = document.getElementById("close-video");
  const iframe = document.getElementById("demo-video");

  // Your sticky header
  const header = document.querySelector(".main-header");

  if (!modal || !openBtn || !closeBtn) return;

  function openModal(e) {
    e.preventDefault();

    modal.style.display = "flex";
    document.body.style.overflow = "hidden";

    // Hide header behind modal
    if (header) {
      header.style.zIndex = "0";
    }
  }

  function closeModal() {
    modal.style.display = "none";
    document.body.style.overflow = "";

    // Stop YouTube playback
    if (iframe) {
      iframe.src = iframe.src;
    }

    // Restore header
    if (header) {
      header.style.zIndex = "350";
    }
  }

  openBtn.addEventListener("click", openModal);
  closeBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeModal();
    }
  });
});

// console.log("CodeByShakir JS Loaded!");

// document.querySelector('.fa-tools')